export default __webpack_public_path__ + "static/media/icon-import-fichier.8b7742b2.svg";